import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './styles.css'

export default class ReturnMusicsMenuScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            screen: 'Main'
        }
    }

    render() {
        return(
            <div className="back-cover">
                <div className="main">
                    <div className="screen">
                        {/* <img src="http://iphonewrd.com/img/loading.gif" /> */}
                        <div className='ipodmenulist'>

                            <button className="buttonGoToMenu" onClick={() => this.goToMusicsScreen}>
                                <Link to={'/music/1'} className="goTo">GummyBearz</Link>
                            </button>

                            <button className="buttonGoToMenu" onClick={() => this.goToMusicsScreen}>
                                <Link to={'/music/2'} className="goTo">Beat de Trap</Link>
                            </button>

                        </div>
                    </div>
                    <div className="navigator">        
                        <div className="keys">       
                            {/* <!--nav keys--> */}

                            <span className="menu-btn">MENU</span>
                        
                            <img className="fwd" src="https://cdn2.iconfinder.com/data/icons/snipicons/5000/fast-forward-256.png" />
                            
                            <img className="bkd" src="https://cdn2.iconfinder.com/data/icons/snipicons/5000/fast-backward-128.png" />
                            
                            <img className="play-pause" src="https://cdn2.iconfinder.com/data/icons/snipicons/5000/play-128.png" />
                        
                            <div className="play">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }


}



